'use client';

import { getLabelId, getCaptionId } from "./constants.js";
const getA11yTriggerProps = (id, { caption }) => ({
  "aria-describedby": caption ? getCaptionId(id) : void 0,
  "aria-labelledby": getLabelId(id)
});
export {
  getA11yTriggerProps
};
